import React, { FC } from 'react';
import { BoxProps, useTheme } from '@material-ui/core';

import { Icons, SvgIcon } from '../SvgIcon';
import { Tooltip } from '../Tooltip';
import { StyledIconWrapper } from './Atoms';

export type DraggableItemIconProps = BoxProps & {
  icon: Icons;
  left?: boolean;
  right?: boolean;
  variant?: 'primary';
  size?: 'large' | 'medium' | 'small';
  tooltip?: string;
};

export const DraggableItemIcon: FC<DraggableItemIconProps> = ({
  icon,
  variant,
  left,
  right,
  size,
  tooltip,
  color,
  ...other
}: DraggableItemIconProps) => {
  const theme = useTheme();
  const background = variant === 'primary' ? theme.palette.primary.main : '#fdfaf5';
  const foreground = variant === 'primary' ? 'white' : 'rgba(0, 0, 0, 0.3)';

  return (
    <StyledIconWrapper
      border="none"
      display="flex"
      bgcolor={background}
      color={foreground}
      {...other}
    >
      {!!tooltip ? (
        <Tooltip title={tooltip} placement="top">
          <SvgIcon
            large={size === 'large'}
            small={size === 'small'}
            icon={icon}
            color={foreground}
          />
        </Tooltip>
      ) : (
        <SvgIcon large={size === 'large'} small={size === 'small'} icon={icon} color={foreground} />
      )}
    </StyledIconWrapper>
  );
};
